const state = {
  partners: [],
  partner: {},
};

export default state;
